module.exports = __webpack_public_path__ + "static/media/back-button.3d837ff0.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/icons/back-button.svg
 ** module id = 124
 ** module chunks = 0
 **/